export default {
  init: function () {

    // set the price for the default selected value
    let total_price = $("#ginput_base_price_2_17").val();
    $(".ginput_container_product_calculation span:nth-child(3)").text(total_price);

    // handle user change
    $("#input_2_4 input[name='input_4']").click(function () {

      let price_value = $(this).val();
      $(".ginput_container_product_calculation span:nth-child(3)").text(price_value);
    });

  },
};




// WEBPACK FOOTER //
// ./scripts/routes/gift-card.js